export class HeaderState {
	showDrawer: boolean;
	showExportDialog: boolean;

	constructor() {
		this.showDrawer = false;
		this.showExportDialog = false;
	}
}